<div class="d-flex gap-2">
    <ds-tag class="d-flex gap-2" [tagInput]="tagConfig" (btnClick)="onTagRemoved($event)"></ds-tag>
</div>